import { Navigate, Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import { usePlatformAuth } from '@/hooks/usePlatformAuth'

/** Guard de la capa de plataforma: exige sesión de plataforma con rol SYSTEM_ADMIN. */
export default function PlatformProtectedRoute() {
    const { platformUser, isAuthenticated, isLoading, initAuth } = usePlatformAuth()

    useEffect(() => { initAuth() }, [initAuth])

    if (isLoading) {
        return (
            <div className="flex h-screen items-center justify-center bg-slate-900 text-slate-200">
                <div className="text-lg">Cargando…</div>
            </div>
        )
    }

    const ok = isAuthenticated && platformUser?.role === 'SYSTEM_ADMIN'
    return ok ? <Outlet /> : <Navigate to="/platform/login" replace />
}
